export enum SubStatusEnum {
  REQUESTED = "REQUESTED",
  CONFIRMED = "CONFIRMED",
  AWAITING_VEHICLE_ARRIVAL = "AWAITING_VEHICLE_ARRIVAL",
  AWAITING_BUDGET = "AWAITING_BUDGET",
  TECHNICAL_REGULATION = "TECHNICAL_REGULATION",
  AWAITING_APPROVAL = "AWAITING_APPROVAL",
  BUDGET_APPROVED = "BUDGET_APPROVED",
  MAINTENANCE_STARTED = "MAINTENANCE_STARTED",
  AWAITING_INVOICES = "AWAITING_INVOICES",
  VALIDATION_NOTES = "VALIDATION_NOTES",
  REJECTED_NOTES = "REJECTED_NOTES",
  VEHICLE_NO_SHOW = "VEHICLE_NO_SHOW",
  MAINTENANCE_FINISHED = "MAINTENANCE_FINISHED"
}
